"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const search_1 = require("./functions/search");
const inlineGlossary_1 = require("./functions/inlineGlossary");
(0, jquery_1.default)('.timeline-slider').slick({
    infinite: false,
    centerMode: false,
    arrows: true,
    dots: true,
    variableWidth: true,
});
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function initSidebarMenu() {
    (0, jquery_1.default)('.sideNavToggle').on('click', function () {
        (0, jquery_1.default)('.mySidenav').toggleClass('open');
    });
}
initSidebarMenu();
(0, search_1.openSearchBar)();
(0, inlineGlossary_1.inlineGlossary)();
